// src/redux/sagas/tpnConfigSaga.ts
import { call, put,takeEvery } from 'redux-saga/effects';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import { INTEGRATIONS_BASE_URL } from '../../api/config';
import {
  fetchTpnConfigRequest,
  fetchTpnConfigSuccess,
  fetchTpnConfigFailure,
} from '../slices/tpnConfigSlice';
import { shouldSkipApiCalls } from '../../utils/appConfig';
import { TpnConfig } from '../../types/tpnConfig';

function* fetchTpnConfigSaga(): Generator<any, void, any> {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    const emptyConfig: TpnConfig = { tpn_config: [] };
    yield put(fetchTpnConfigSuccess(emptyConfig));
    return;
  }

  try {
    // Call new Integrations API with direct baseURL
    const response = yield call(request, {
      method: 'GET',
      url: ENDPOINTS.INTEGRATIONS_API_PATH,
      base: INTEGRATIONS_BASE_URL,
    });

    // Extract integrations from response
    const integrations = response?.data?.data || [];

    // Filter for PAYMENT and POS integrations (flexible matching)
    const paymentIntegrations = integrations.filter((item: any) => {
      const integrationType = (item.integrationType || '').toLowerCase();
      const state = (item.state || '').toLowerCase();
      
      return (
        (integrationType.includes('payment') || integrationType.includes('pos')) &&
        state.includes('active')
      );
    });

    // Transform to TpnConfig format
    const transformedData: TpnConfig = {
      tpn_config: paymentIntegrations
    };

    yield put(fetchTpnConfigSuccess(transformedData));
  } catch (error: any) {
    yield put(fetchTpnConfigFailure(error.message || 'Failed to fetch TPN config'));
  }
}

export function* watchTpnConfigSaga() {
  yield takeEvery(fetchTpnConfigRequest.type, fetchTpnConfigSaga);
}
